import { render, staticRenderFns } from "./CustomColor.vue?vue&type=template&id=3b4aa882&scoped=true&"
import script from "./CustomColor.vue?vue&type=script&lang=js&"
export * from "./CustomColor.vue?vue&type=script&lang=js&"
import style0 from "./CustomColor.vue?vue&type=style&index=0&id=3b4aa882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4aa882",
  null
  
)

export default component.exports